import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const aujourdhui = () => new Date().toISOString().slice(0, 10);

// Décale une date AAAA-MM-JJ d'un nombre de jours (calcul en UTC : pas de piège d'heure d'été)
const decaler = (date: string, jours: number) => {
  const d = new Date(`${date}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + jours);
  return d.toISOString().slice(0, 10);
};

interface Props {
  value: string;
  onChange: (date: string) => void;
}

/** Sélecteur de date du folio : jour précédent / champ date / jour suivant (pas au-delà d'aujourd'hui). */
const FolioDateNav: React.FC<Props> = ({ value, onChange }) => {
  const estAujourdhui = value >= aujourdhui();
  return (
    <div className="flex items-center gap-1.5">
      <button
        type="button"
        onClick={() => onChange(decaler(value, -1))}
        className="son-icon-btn"
        aria-label="Jour précédent"
        title="Jour précédent"
      >
        <ChevronLeft className="h-4 w-4" />
      </button>
      <input
        type="date"
        value={value}
        max={aujourdhui()}
        onChange={(e) => e.target.value && onChange(e.target.value)}
        className="border border-gray-200 rounded-xl px-3 py-2 text-gray-700"
      />
      <button
        type="button"
        onClick={() => onChange(decaler(value, 1))}
        disabled={estAujourdhui}
        className="son-icon-btn disabled:opacity-40 disabled:cursor-not-allowed"
        aria-label="Jour suivant"
        title="Jour suivant"
      >
        <ChevronRight className="h-4 w-4" />
      </button>
    </div>
  );
};

export default FolioDateNav;
